import { useEffect, useState } from "react";
import { Player } from 'media-stream-player';
import "./ClawCameraFeeds.scss";

const SingleMachineCameraFeed = ({ machineID, machineName, overlayContent = null, footerContent = null }) => {
    const [viewType, setViewType] = useState('front'); // 'front' or 'top'
    const [switchingFeed, setSwitchingFeed] = useState(false);

    useEffect(() => {
        setSwitchingFeed(true);
        setViewType('front');

        const resetTimer = setTimeout(() => {
            setSwitchingFeed(false);
        }, 120);

        return () => clearTimeout(resetTimer);
    }, [machineID]);

    // Define camera feeds for this machine
    const cameraFeeds = {
        1: {
            front: 'clawcam1.twitchcampaignstudio.com',
            top: 'clawcam2.twitchcampaignstudio.com'
        },
        2: {
            front: 'clawcam3.twitchcampaignstudio.com',
            top: 'clawcam4.twitchcampaignstudio.com'
        }
    };

    const currentFeed = cameraFeeds[machineID]?.[viewType];

    const toggleView = () => {
        setSwitchingFeed(true);
        setViewType(prevView => prevView === 'front' ? 'top' : 'front');

        setTimeout(() => {
            setSwitchingFeed(false);
        }, 100);
    };

    return (
        <div className="fl-column">
            <div className="fl-row" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                <h4 style={{ margin: 0 }}>{machineName} Camera</h4>
                <div className="fl-row compact">
                    <button 
                        className={`standard-button claw-view-toggle ${viewType === 'front' ? '' : 'button-inactive'}`}
                        type="button"
                        onClick={() => {
                            if (viewType !== 'front') toggleView();
                        }}
                    >
                        Front View
                    </button>
                    <button 
                        className={`standard-button claw-view-toggle ${viewType === 'top' ? '' : 'button-inactive'}`}
                        type="button"
                        onClick={() => {
                            if (viewType !== 'top') toggleView();
                        }}
                    >
                        Top View
                    </button>
                </div>
            </div>
            <div className="claw-feed-holder">
                {overlayContent && (
                    <div className="claw-feed-overlay">
                        {overlayContent}
                    </div>
                )}
                {!switchingFeed && currentFeed && (
                    <Player
                        key={`${machineID}-${viewType}-${currentFeed}`}
                        hostname={currentFeed}
                        initialFormat="RTP_H264"
                        secure
                        autoPlay
                        autoRetry
                    />
                )}
            </div>
            {footerContent && (
                <div className="claw-feed-footer">
                    {footerContent}
                </div>
            )}
        </div>
    );
};

export default SingleMachineCameraFeed;
